import { IconType } from '@assembly-js/design-system';

import { CustomFieldType } from 'src/store/clients/types';

// Single source for how a custom field type is named and drawn, so every
// surface (record, menu, settings) agrees. Insertion order is the display order.
export const CUSTOM_FIELD_TYPE_META = {
  text: { label: 'Text', icon: 'Text' },
  number: { label: 'Number', icon: 'Number' },
  date: { label: 'Date', icon: 'Calendar' },
  select: { label: 'Select', icon: 'List' },
  multiSelect: { label: 'Multi-select', icon: 'Tag' },
  email: { label: 'Email', icon: 'Email' },
  phoneNumber: { label: 'Phone', icon: 'MobileNumber' },
  url: { label: 'URL', icon: 'Link' },
  address: { label: 'Address', icon: 'Location' },
  checkbox: { label: 'Checkbox', icon: 'Check' },
} satisfies Record<CustomFieldType, { label: string; icon: IconType }>;

export const CUSTOM_FIELD_TYPES = Object.keys(
  CUSTOM_FIELD_TYPE_META,
) as CustomFieldType[];
